import { render, staticRenderFns } from "./EmailConfiguration.vue?vue&type=template&id=e317bd76&scoped=true"
import script from "./EmailConfiguration.vue?vue&type=script&lang=js"
export * from "./EmailConfiguration.vue?vue&type=script&lang=js"
import style0 from "./EmailConfiguration.vue?vue&type=style&index=0&id=e317bd76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e317bd76",
  null
  
)

export default component.exports